export default {
	title: 'マイプロフィール',
	messages: {
		choose_plan: 'プランを選択',
		unlock_immediately: 'すべての機能をすぐに利用可能にする',
		current_subscription: '現在のサブスクリプション'
	},
	language: {
		title: '言語',
		description: 'インターフェースの表示言語を選びます',
		languages: {
			de: 'ドイツ語',
			en: '英語',
			es: 'スペイン語',
			fr: 'フランス語',
			hi: 'ヒンディー語',
			it: 'イタリア語',
			ja: '日本語',
			pt: 'ポルトガル語',
			zh: '中国語（普通話）'
		}
	},
	theme: {
		title: 'テーマ'
	},
	actions: {
		manage_subscription: 'サブスクリプションを管理'
	},
	api_access: {
	  title: "APIアクセス（MCPサーバー）",
	  description: "Model Context Protocol を介して、AIエージェント（Claude、ChatGPT など）が Gerositus プロジェクトにアクセスできるようにします。トークンはあなたと同じアクセス権を付与します — 秘密にしてください。",
	  endpoint: "MCPエンドポイントURL",
	  no_token: "まだトークンがありません — 生成してAIエージェントのアクセスを有効にしてください。",
	  default_token_name: "デフォルトトークン",
	  status_active: "有効",
	  status_revoked: "失効",
	  created_at: "{{date}} に作成",
	  last_used_at: "最終使用：{{date}}",
	  never_used: "未使用",
	  generate: "トークンを生成",
	  regenerate: "トークンを更新",
	  revoke: "トークンを失効",
	  copy: "コピー",
	  copied: "クリップボードにコピーしました",
	  copy_failed: "コピーに失敗しました",
	  config_example: "MCPクライアント設定例",
	  reveal_title: "今すぐトークンを保存してください",
	  reveal_done: "保存しました",
	  reveal_warning_title: "このトークンが表示されるのはこの一度だけです",
	  reveal_warning_body: "安全な場所（パスワードマネージャー）にコピーしてください。失うと再発行が必要です。このトークンを持つ者は誰でもプロジェクトを閲覧できます。",
	  regenerate_confirm_title: "アクセストークンを更新しますか？",
	  regenerate_confirm_body: "現在のトークンは即座に失効し、新しいトークンが発行されます。古いトークンを使っているAIエージェントは再設定が必要です。",
	  revoke_confirm_title: "アクセストークンを失効しますか？",
	  revoke_confirm_body: "このトークンを使っているAIエージェントはアクセスを失います。いつでも新しく生成できます。"
	}
};
